import Service from 'additiv-services/services/core/service';
import { getCustomServiceLayerHeader } from 'additiv-services/setup';
import { CUSTOM_SERVICE_LAYER_SERVICES, getCustomServiceLayerBaseUrl } from '../constants';

class ContactActivation extends Service {
    static #baseServiceUrl = getCustomServiceLayerBaseUrl(CUSTOM_SERVICE_LAYER_SERVICES.CONTACT_ACTIVATION);

    static getContactActivationHistory({
        contactId,
    }) {
        return Service.getRequest(`${this.#baseServiceUrl}/${contactId}/history`, {
            isSecure: true,
            axiosSetup: { headers: getCustomServiceLayerHeader() },
        });
    }
}

export default ContactActivation;
